export const checkboxTokens = {
  'checkbox-size': '18px',
  'checkbox-border-color': 'var(--dp-color-border)',
  'checkbox-border-radius': 'var(--dp-border-radius-sm)',
  'checkbox-checked-bg': 'var(--dp-color-primary)',
  'checkbox-checked-icon-color': 'var(--dp-color-text-inverse)',
  'checkbox-hover-border-color': 'var(--dp-color-primary)',
  'checkbox-disabled-opacity': '0.5',
  'checkbox-label-gap': 'var(--dp-spacing-sm)',
} as const;
